'use strict';

import execute_on from "../../../../libs/execute-on";
import {swalWarningFire} from "../../../../plugins/sweet-alert/sweet-alert-default";

execute_on('admin.invoice.issue.create', function() {
    const allInvoiceDetailsList = $('.selectInvoiceDetailsList').html();

    $(".selectCompany").on('change', async function () {
        let response = await fetch('/admin/invoice/issue/get-company-invoice-details/' + $(this).val());
        let allowedValues = await response.json();

        $('.selectInvoiceDetailsList').empty();
        resetInvoiceDetails('reset');

        $(allInvoiceDetailsList).each(function () {
            if (allowedValues.includes($(this).val()) || $(this).val() === "") {
                $('.selectInvoiceDetailsList').append($(this));
            }
        });

        // Odświeżenie select2
        $('.selectInvoiceDetailsList').trigger('change.select2');
    });

    $(".selectInvoiceDetailsList").on('change', function () {

        $.ajax({
            url: '/admin/invoice/issue/get-company-due-date/' + $('.selectInvoiceDetailsList').val(),
            method: 'GET',
            dataType: 'text',
            success: function(data) {
                $('#issue\\.due_date\\.d').val(data);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.error('Error fetching data:', textStatus, errorThrown);
            }
        });

        resetInvoiceDetails($(this).val());
    });

    $(".showInvoicePreview").on('click', function (event) {
        event.preventDefault();

        const formId = 'invoiceIssueForm';
        $('#' + formId + ' input, #' + formId + ' select, #' + formId + ' textarea').each(function() {

            let input = $(this);
            let inputName = input.attr('name');
            let inputValue = input.val();

            // Utwórz nowy ukryty input z tymi samymi nazwą i wartością
            let hiddenInput = $('<input>').attr({
                type: 'hidden',
                name: inputName,
                value: inputValue
            });

            // Dodaj ukryty input do formularza docelowego
            $('.showInvoicePreviewForm').append(hiddenInput);
        });

        $(document).find(".showInvoicePreviewForm").submit();

        return false;
    });
});

function resetInvoiceDetails(selectedInvoiceDetailsId) {
    const invoiceDetailsData = $('.selectInvoiceDetailsList').data('invoice-details');
    const selectedInvoiceDetailsData = invoiceDetailsData[selectedInvoiceDetailsId]

    const $invoiceDetailBuyerSpan = $(".companyInvoiceDetails .invoiceDetailBuyer span");
    const $invoiceDetailFirstNameSpan = $(".companyInvoiceDetails .invoiceDetailFirstName span");
    const $invoiceDetailLastNameSpan = $(".companyInvoiceDetails .invoiceDetailLastName span");
    const $invoiceDetailAddressSpan = $(".companyInvoiceDetails .invoiceDetailAddress span");
    const $invoiceDetailPostalCodeSpan = $(".companyInvoiceDetails .invoiceDetailPostalCode span");
    const $invoiceDetailCitySpan = $(".companyInvoiceDetails .invoiceDetailCity span");
    const $invoiceDetailCountrySpan = $(".companyInvoiceDetails .invoiceDetailCountry span");
    const $invoiceDetailTaxSpan = $(".companyInvoiceDetails .invoiceDetailTax span");
    const $invoiceDetailContactNameSpan = $(".companyInvoiceDetails .invoiceDetailContactName span");
    const $invoiceDetailSendInvoiceToSpan = $(".companyInvoiceDetails .invoiceDetailSendInvoiceTo span");
    const $invoiceDetailAdditionalInfo = $(".invoiceAdditionalInfo");

    if (selectedInvoiceDetailsData) {
        $invoiceDetailBuyerSpan.text(selectedInvoiceDetailsData.buyer_name);
        $invoiceDetailAddressSpan.text(selectedInvoiceDetailsData.address);
        $invoiceDetailPostalCodeSpan.text(selectedInvoiceDetailsData.postal_code);
        $invoiceDetailCitySpan.text(selectedInvoiceDetailsData.city);
        $invoiceDetailCountrySpan.text(selectedInvoiceDetailsData.country.name);
        $invoiceDetailTaxSpan.text(selectedInvoiceDetailsData.tax_number);
        $invoiceDetailContactNameSpan.text(selectedInvoiceDetailsData.contact_name);
        $invoiceDetailSendInvoiceToSpan.text(selectedInvoiceDetailsData.additional_email);
        $invoiceDetailAdditionalInfo.val(selectedInvoiceDetailsData.additional_info);

        return;
    }

    $invoiceDetailBuyerSpan.text('');
    $invoiceDetailFirstNameSpan.text('');
    $invoiceDetailLastNameSpan.text('');
    $invoiceDetailAddressSpan.text('');
    $invoiceDetailPostalCodeSpan.text('');
    $invoiceDetailCitySpan.text('');
    $invoiceDetailCountrySpan.text('');
    $invoiceDetailTaxSpan.text('');
    $invoiceDetailContactNameSpan.text('');
    $invoiceDetailSendInvoiceToSpan.text('');
    $invoiceDetailAdditionalInfo.val('');
}
